import React, { useState } from 'react';
import { s, docStyles, ajudaStyles } from './TissStyles';
import { StatusBadge, DocSection, DocTable } from './TissShared';

// ==================== DOCUMENTACAO TECNICA ====================

export function DocContent() {
  return (
    <>
      <div style={s.card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <div>
            <div style={{ fontSize: '16px', fontWeight: '700', color: '#1a1a2e' }}>Documentacao TISS UNIMED</div>
            <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>Laboratorio Santa Rita - VIP Tecnologia LTDA | TISS v4.02.00</div>
          </div>
          <span style={{ ...s.badge, backgroundColor: '#e3f2fd', color: '#1976d2' }}>v1.0</span>
        </div>
        <p style={docStyles.p}>
          Documentacao completa do modulo de integracao TISS com a UNIMED Divinopolis. Clique em cada secao para expandir/recolher.
        </p>
      </div>

      {/* 1. Visao Geral */}
      <div style={s.card}>
        <DocSection title="1. Visao Geral" defaultOpen>
          <p style={docStyles.p}>
            <strong>Objetivo:</strong> Automatizar o envio de guias SADT (Servicos Auxiliares de Diagnostico e Terapia) de exames laboratoriais para a operadora UNIMED Divinopolis, substituindo o processo manual realizado hoje no portal web da operadora.
          </p>
          <DocTable
            headers={['Parametro', 'Valor']}
            rows={[
              ['Padrao', 'TISS v4.02.00 (Troca de Informacoes em Saude Suplementar)'],
              ['Comunicacao', 'WebService SOAP 1.1 (Document/Literal)'],
              ['Regulamentacao', 'ANS (Agencia Nacional de Saude Suplementar)'],
            ]}
          />
          <DocTable
            headers={['Parte', 'Descricao']}
            rows={[
              ['Prestador', 'Laboratorio Santa Rita LTDA (Itapecerica/MG)'],
              ['Operadora', 'UNIMED Divinopolis (Registro ANS: 319121)'],
              ['Desenvolvimento', 'VIP Tecnologia LTDA'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Escopo da Integracao</div>
          <DocTable
            headers={['Funcionalidade', 'Status']}
            rows={[
              ['Verificacao de Elegibilidade', <span style={docStyles.statusOk}>Implementado</span>],
              ['Solicitacao de Procedimentos (Guia SADT)', <span style={docStyles.statusOk}>Implementado</span>],
              ['Envio de Lotes de Guias', <span style={docStyles.statusOk}>Implementado</span>],
              ['Cancelamento de Guias', <span style={docStyles.statusOk}>Implementado</span>],
              ['Consulta de Status de Protocolo', <span style={docStyles.statusOk}>Implementado</span>],
              ['Envio Automatico via Worker', <span style={docStyles.statusOk}>Implementado</span>],
              ['Download PDF da Guia', <span style={docStyles.statusOk}>Implementado</span>],
            ]}
          />
        </DocSection>
      </div>

      {/* 2. Ambiente e Credenciais */}
      <div style={s.card}>
        <DocSection title="2. Ambiente e Credenciais">
          <div style={docStyles.sectionTitle}>Ambiente de Homologacao (HML)</div>
          <DocTable
            headers={['Parametro', 'Valor']}
            rows={[
              ['Base URL', <span style={{ fontFamily: 'monospace', fontSize: '11px' }}>https://s20atd-hml.divinopolis.sgusuite.com.br/WSTiss3/http/v4_02_00/</span>],
              ['Login', <code style={docStyles.codeInline}>14412401389</code>],
              ['Senha', <code style={docStyles.codeInline}>Unimed@2026</code>],
              ['Registro ANS', <code style={docStyles.codeInline}>319121</code>],
              ['Versao TISS', <code style={docStyles.codeInline}>4.02.00</code>],
            ]}
          />
          <div style={docStyles.sectionTitle}>Dados dos Prestadores</div>
          <DocTable
            headers={['Local', 'Nome', 'CNPJ', 'CNES', 'Cod. Operadora']}
            rows={[
              [<strong>01</strong>, 'Matriz', '40.138.105/0001-26', '-', <span style={docStyles.statusPend}>Pendente</span>],
              [<strong>02</strong>, 'Itapecerica', '40.138.105/0001-26', '0483907', <span style={docStyles.statusPend}>Pendente</span>],
              [<strong>04</strong>, 'Pedra do Indaia', '40.138.105/0003-98', '3352412', <span style={docStyles.statusPend}>Pendente</span>],
              [<strong>CA</strong>, 'Camacho', '40.138.105/0002-07', '5810086', <span style={docStyles.statusPend}>Pendente</span>],
            ]}
          />
          <div style={docStyles.note}>
            <strong>Nota:</strong> O campo "Cod. Operadora" (codigoPrestadorNaOperadora) sera informado pela UNIMED apos cadastro no sistema deles. Enquanto nao informado, o sistema utiliza o CNPJ como identificacao.
          </div>
        </DocSection>
      </div>

      {/* 3. Arquitetura Tecnica */}
      <div style={s.card}>
        <DocSection title="3. Arquitetura Tecnica">
          <pre style={docStyles.pre}>{`+--------------------------------------------------+
|                    FRONTEND                       |
|   client/src/pages/TissUnimed.js                  |
|   7 abas: Dashboard | Guias | Lotes |            |
|           Elegibilidade | Config | Log | Doc      |
+--------------------------------------------------+
              |  REST API (JWT Auth)
              v
+--------------------------------------------------+
|                    BACKEND                        |
|   routes_organized/tiss-unimed/ (10 modulos)      |
|                                                   |
|   tiss-config.js -------> Config + Prestadores    |
|   tiss-guias.js --------> CRUD + Envio + Status   |
|   tiss-guia-pdf.js -----> Download PDF da Guia    |
|   tiss-pdf-builder.js --> Gerador PDF (PDFKit)    |
|   tiss-lotes.js --------> Lotes de Faturamento    |
|   tiss-elegibilidade.js > Elegibilidade           |
|   tiss-worker.js -------> Auto-envio (polling)    |
|   tiss-transacoes.js ---> Log de Transacoes       |
|   tiss-data-mapper.js --> Queries SQL Server      |
|   tiss-client.js -------> Core SOAP Client        |
+--------------------------------------------------+
      |                            |
      v                            v
+------------------+    +------------------------+
|   PostgreSQL     |    |     SQL Server          |
|  (auth + TISS)   |    | (dados laboratoriais)   |
|                  |    |                         |
|  tiss_config     |    |  SOLICITACAO            |
|  tiss_prestadores|    |  SOLICITACAO_GUIA       |
|  tiss_guias      |    |  SOLICITACAO_EXAMES     |
|  tiss_lotes      |    |  SOLICITACAO_EXAMES_GUIA|
|  tiss_transacoes |    |  PACIENTE               |
|  tiss_elegib...  |    |  CONVENIO               |
|  tiss_worker_log |    |  SOLICITANTE            |
+------------------+    |  TABELALAUDO            |
                        +------------------------+
      |
      v  SOAP 1.1 (ISO-8859-1)
+---------------------------+
|   UNIMED Divinopolis      |
|   WebService TISS v4.02   |
|   (HML / PRD)             |
+---------------------------+`}</pre>
          <div style={docStyles.sectionTitle}>Modulos do Backend</div>
          <DocTable
            headers={['Modulo', 'Linhas', 'Descricao']}
            rows={[
              [<code style={docStyles.codeInline}>tiss-client.js</code>, '~612', 'Core SOAP: XML builders, MD5 hash, sender, response parser'],
              [<code style={docStyles.codeInline}>tiss-data-mapper.js</code>, '~230', 'Queries SQL Server + mapeamento para formato TISS'],
              [<code style={docStyles.codeInline}>tiss-config.js</code>, '~116', 'CRUD config + teste de conexao SOAP'],
              [<code style={docStyles.codeInline}>tiss-elegibilidade.js</code>, '~115', 'Verificacao de elegibilidade com cache 24h'],
              [<code style={docStyles.codeInline}>tiss-guias.js</code>, '~375', 'CRUD guias + envio + status + cancelamento'],
              [<code style={docStyles.codeInline}>tiss-guia-pdf.js</code>, '~170', 'Endpoint GET PDF da guia (auth dual JWT/API Key)'],
              [<code style={docStyles.codeInline}>tiss-pdf-builder.js</code>, '~310', 'Gerador PDF modular com PDFKit (A4, ERP style)'],
              [<code style={docStyles.codeInline}>tiss-lotes.js</code>, '~242', 'Lotes de faturamento (criar, enviar, status)'],
              [<code style={docStyles.codeInline}>tiss-worker.js</code>, '~309', 'Worker de envio automatico (polling periodico)'],
              [<code style={docStyles.codeInline}>tiss-transacoes.js</code>, '~40', 'Log de transacoes SOAP'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Dependencias Principais</div>
          <ul>
            <li style={docStyles.li}><code style={docStyles.codeInline}>fast-xml-parser</code> — Parse e build de XML TISS</li>
            <li style={docStyles.li}><code style={docStyles.codeInline}>undici</code> — HTTP client com suporte a ISO-8859-1</li>
            <li style={docStyles.li}><code style={docStyles.codeInline}>pdfkit</code> — Geracao de PDF server-side</li>
            <li style={docStyles.li}><code style={docStyles.codeInline}>crypto</code> — Hash MD5 nativo (padrao TISS)</li>
          </ul>
        </DocSection>
      </div>

      {/* 4. Banco de Dados */}
      <div style={s.card}>
        <DocSection title="4. Banco de Dados (PostgreSQL — 7 Tabelas TISS)">
          <p style={docStyles.p}>Todas as tabelas TISS ficam no PostgreSQL (mesmo banco de auth e config do sistema). Os dados de atendimento sao lidos do SQL Server (somente leitura).</p>
          <DocTable
            headers={['Tabela', 'Descricao', 'Chaves Importantes']}
            rows={[
              [<code style={docStyles.codeInline}>tiss_config</code>, 'Chave-valor para configuracoes gerais', 'chave (UNIQUE), valor'],
              [<code style={docStyles.codeInline}>tiss_prestadores</code>, 'Um registro por LOCAL (unidade)', 'local_id (UNIQUE), cnpj, cnes, codigo_operadora'],
              [<code style={docStyles.codeInline}>tiss_guias</code>, 'Cada guia SADT enviada', 'numero_guia_prestador, status, xml_request/response'],
              [<code style={docStyles.codeInline}>tiss_lotes</code>, 'Lotes de guias para faturamento', 'numero_lote (UNIQUE), status, total_guias'],
              [<code style={docStyles.codeInline}>tiss_transacoes</code>, 'Log de cada transacao SOAP', 'operacao, guia_id, sucesso, duracao_ms'],
              [<code style={docStyles.codeInline}>tiss_elegibilidade_cache</code>, 'Cache de elegibilidade (TTL 24h)', 'numero_carteira, elegivel, expires_at'],
              [<code style={docStyles.codeInline}>tiss_worker_log</code>, 'Log de cada ciclo do worker', 'total_enviados, total_erros, detalhes (JSONB)'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Status da Guia</div>
          <DocTable
            headers={['Status', 'Descricao']}
            rows={[
              [<StatusBadge status="pendente" />, 'Criada, ainda nao enviada'],
              [<StatusBadge status="enviado" />, 'Enviada, aguardando resposta/autorizacao'],
              [<StatusBadge status="autorizado" />, 'Autorizada pela UNIMED'],
              [<StatusBadge status="negado" />, 'Negada pela UNIMED (com motivo)'],
              [<StatusBadge status="erro" />, 'Erro no envio (SOAP Fault, timeout, glosa)'],
              [<StatusBadge status="cancelado" />, 'Cancelada pelo prestador'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Status do Lote</div>
          <DocTable
            headers={['Status', 'Descricao']}
            rows={[
              [<StatusBadge status="pendente" />, 'Criado, nao enviado'],
              [<StatusBadge status="enviado" />, 'Enviado, aguardando processamento'],
              [<StatusBadge status="aceito" />, 'Aceito pela operadora'],
              [<StatusBadge status="rejeitado" />, 'Rejeitado pela operadora'],
              [<StatusBadge status="parcial" />, 'Parcialmente aceito'],
              [<StatusBadge status="erro" />, 'Erro no envio'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Tabelas SQL Server (Fonte — somente leitura)</div>
          <DocTable
            headers={['Tabela', 'Papel na Integracao']}
            rows={[
              ['SOLICITACAO', 'Registro do atendimento (LOCAL, PROTOCOLO, DATA, PACIENTE)'],
              ['SOLICITACAO_GUIA', 'Guia do convenio (carteirinha, plano, autorizacao, medico)'],
              ['SOLICITACAO_EXAMES_GUIA', 'Junction table exame-guia com VALOR e VALORFATURADO'],
              ['PACIENTE', 'Nome, CPF, data de nascimento'],
              ['CONVENIO', 'Razao social (filtro: LIKE \'%UNIMED%\')'],
              ['SOLICITANTE', 'Medico solicitante (nome, CRM, UF_CONSELHO)'],
              ['TABELALAUDO', 'Codigo de procedimento TUSS e descricao'],
            ]}
          />
        </DocSection>
      </div>

      {/* 5. Referencia de Codigos TISS */}
      <div style={s.card}>
        <DocSection title="5. Referencia de Codigos e Dominios TISS">
          <div style={docStyles.note}>
            <strong>Referencia rapida:</strong> Codigos padronizados pelo XSD TISS v4.02.00. Valores invalidos causam erro <code style={docStyles.codeInline}>Unmarshalling Error</code> na operadora.
          </div>

          <div style={docStyles.sectionTitle}>statusSolicitacao (dm_statusSolicitacao)</div>
          <p style={docStyles.p}>Retornado pela UNIMED na resposta de solicitacao de procedimentos. Determina se a guia foi autorizada, negada ou parcialmente autorizada.</p>
          <DocTable
            headers={['Codigo', 'Significado', 'Mapeamento no Sistema', 'Descricao']}
            rows={[
              [<code style={docStyles.codeInline}>1</code>, 'Autorizado', <StatusBadge status="autorizado" />, 'Todos os procedimentos foram autorizados pela operadora'],
              [<code style={docStyles.codeInline}>2</code>, 'Negado', <StatusBadge status="negado" />, 'A operadora negou a solicitacao. Verificar motivo da negativa'],
              [<code style={docStyles.codeInline}>3</code>, 'Autorizado Parcial', <StatusBadge status="autorizado" />, 'Alguns procedimentos autorizados, outros glosados. Pode incluir codigos de glosa em motivosNegativa'],
              [<code style={docStyles.codeInline}>4</code>, 'Cancelado pelo Prestador', <StatusBadge status="negado" />, 'A guia foi cancelada a pedido do prestador'],
              [<code style={docStyles.codeInline}>5</code>, 'Cancelado pela Operadora', <StatusBadge status="negado" />, 'A operadora cancelou a guia unilateralmente'],
            ]}
          />
          <div style={docStyles.warn}>
            <strong>Atencao — Codigo 3 (Parcial):</strong> Mesmo sendo parcial, e uma autorizacao valida. O sistema grava como "autorizado" e extrai os codigos de glosa dos procedimentos nao aprovados no campo "motivo negativa".
          </div>

          <div style={docStyles.sectionTitle}>tipoAtendimento (dm_tipoAtendimento)</div>
          <p style={docStyles.p}>Define o tipo de atendimento na guia executada (lote/faturamento). O laboratorio usa <code style={docStyles.codeInline}>23</code> (Exame) — confirmado pela UNIMED.</p>
          <DocTable
            headers={['Codigo', 'Descricao', 'Uso']}
            rows={[
              [<code style={docStyles.codeInline}>01</code>, 'Remoção', ''],
              [<code style={docStyles.codeInline}>02</code>, 'Pequena Cirurgia', ''],
              [<code style={docStyles.codeInline}>03</code>, 'Outras Terapias', ''],
              [<code style={docStyles.codeInline}>04</code>, 'Consulta', ''],
              [<code style={docStyles.codeInline}>08</code>, 'Quimioterapia', ''],
              [<code style={docStyles.codeInline}>09</code>, 'Radioterapia', ''],
              [<code style={docStyles.codeInline}>10</code>, 'TRS (Terapia Renal Substitutiva)', ''],
              [<code style={docStyles.codeInline}>13</code>, 'Pequeno Atendimento', ''],
              [<code style={{ ...docStyles.codeInline, backgroundColor: '#e8f5e9', color: '#2e7d32' }}>23</code>, 'Exame', <strong style={{ color: '#2e7d32' }}>Laboratorio Santa Rita</strong>],
            ]}
          />
          <div style={docStyles.warn}>
            <strong>Cuidado:</strong> Os codigos <code style={docStyles.codeInline}>05</code>, <code style={docStyles.codeInline}>06</code>, <code style={docStyles.codeInline}>07</code>, <code style={docStyles.codeInline}>11</code>, <code style={docStyles.codeInline}>12</code> <strong>NAO existem</strong> no TISS. Enviar valores invalidos causa rejeicao pela operadora com erro "not facet-valid with respect to enumeration".
          </div>

          <div style={docStyles.sectionTitle}>conselhoProfissional (dm_conselhoProfissional)</div>
          <p style={docStyles.p}>Codigo do conselho profissional do medico solicitante. Sempre 2 digitos.</p>
          <DocTable
            headers={['Codigo', 'Conselho']}
            rows={[
              [<code style={docStyles.codeInline}>01</code>, 'CRO (Odontologia)'],
              [<code style={docStyles.codeInline}>06</code>, 'CRM (Medicina)'],
              [<code style={docStyles.codeInline}>07</code>, 'COREN (Enfermagem)'],
              [<code style={docStyles.codeInline}>08</code>, 'CRO (Odontologia — alternativo)'],
              [<code style={docStyles.codeInline}>09</code>, 'CRF (Farmacia)'],
              [<code style={docStyles.codeInline}>10</code>, 'CRP (Psicologia)'],
              [<code style={docStyles.codeInline}>11</code>, 'CREFITO (Fisioterapia)'],
              [<code style={docStyles.codeInline}>12</code>, 'CRN (Nutricao)'],
              [<code style={docStyles.codeInline}>13</code>, 'CRBM (Biomedicina)'],
              [<code style={docStyles.codeInline}>15</code>, 'CREF (Educacao Fisica)'],
              [<code style={docStyles.codeInline}>16</code>, 'CRFA (Fonoaudiologia)'],
              [<code style={docStyles.codeInline}>17</code>, 'CRT (Terapia Ocupacional)'],
            ]}
          />

          <div style={docStyles.sectionTitle}>UF (dm_UF) — Codigo IBGE</div>
          <p style={docStyles.p}>Codigo IBGE da UF do conselho do medico. Usado em <code style={docStyles.codeInline}>profissionalSolicitante.UF</code>.</p>
          <DocTable
            headers={['Codigo', 'UF', 'Codigo', 'UF', 'Codigo', 'UF']}
            rows={[
              [<code style={docStyles.codeInline}>11</code>, 'RO', <code style={docStyles.codeInline}>29</code>, 'BA', <code style={docStyles.codeInline}>41</code>, 'PR'],
              [<code style={docStyles.codeInline}>12</code>, 'AC', <code style={{ ...docStyles.codeInline, backgroundColor: '#e8f5e9', color: '#2e7d32' }}>31</code>, <strong style={{ color: '#2e7d32' }}>MG</strong>, <code style={docStyles.codeInline}>42</code>, 'SC'],
              [<code style={docStyles.codeInline}>13</code>, 'AM', <code style={docStyles.codeInline}>32</code>, 'ES', <code style={docStyles.codeInline}>43</code>, 'RS'],
              [<code style={docStyles.codeInline}>15</code>, 'PA', <code style={docStyles.codeInline}>33</code>, 'RJ', <code style={docStyles.codeInline}>50</code>, 'MS'],
              [<code style={docStyles.codeInline}>21</code>, 'MA', <code style={docStyles.codeInline}>35</code>, 'SP', <code style={docStyles.codeInline}>51</code>, 'MT'],
              [<code style={docStyles.codeInline}>22</code>, 'PI', <code style={docStyles.codeInline}>52</code>, 'GO', <code style={docStyles.codeInline}>53</code>, 'DF'],
              [<code style={docStyles.codeInline}>23</code>, 'CE', <code style={docStyles.codeInline}>24</code>, 'RN', <code style={docStyles.codeInline}>25</code>, 'PB'],
              [<code style={docStyles.codeInline}>26</code>, 'PE', <code style={docStyles.codeInline}>27</code>, 'AL', <code style={docStyles.codeInline}>28</code>, 'SE'],
            ]}
          />

          <div style={docStyles.sectionTitle}>Outros Dominios da Guia SADT Executada</div>
          <DocTable
            headers={['Campo', 'Valor Usado', 'Significado', 'Observacao']}
            rows={[
              [<code style={docStyles.codeInline}>indicacaoAcidente</code>, <code style={docStyles.codeInline}>9</code>, 'Nao acidente', 'Sempre 9 para exames laboratoriais'],
              [<code style={docStyles.codeInline}>regimeAtendimento</code>, <code style={docStyles.codeInline}>01</code>, 'Hospitalar', 'Campo obrigatorio na guia executada'],
              [<code style={docStyles.codeInline}>viaAcesso</code>, <code style={docStyles.codeInline}>1</code>, 'Via unica', 'maxLength=1 — NAO usar "01"'],
              [<code style={docStyles.codeInline}>tecnicaUtilizada</code>, <code style={docStyles.codeInline}>1</code>, 'Convencional', ''],
              [<code style={docStyles.codeInline}>reducaoAcrescimo</code>, <code style={docStyles.codeInline}>1.00</code>, 'Sem reducao/acrescimo', 'Fator multiplicador do valor'],
              [<code style={docStyles.codeInline}>caraterAtendimento</code>, <code style={docStyles.codeInline}>1</code>, 'Eletivo', '1=Eletivo, 2=Urgencia/Emergencia'],
              [<code style={docStyles.codeInline}>tipoEtapaAutorizacao</code>, <code style={docStyles.codeInline}>1</code>, 'Autorizacao previa', '1=Autorizacao previa, 2=Executante'],
              [<code style={docStyles.codeInline}>atendimentoRN</code>, <code style={docStyles.codeInline}>N</code>, 'Nao e recem-nascido', 'N=Nao, S=Sim'],
              [<code style={docStyles.codeInline}>codigoTabela</code>, <code style={docStyles.codeInline}>22</code>, 'Tabela TUSS', '22=TUSS (Terminologia Unificada)'],
            ]}
          />

          <div style={docStyles.sectionTitle}>Erros Comuns de Validacao XML</div>
          <p style={docStyles.p}>Erros retornados pela operadora quando o XML nao esta conforme o schema XSD.</p>
          <DocTable
            headers={['Erro', 'Causa', 'Solucao']}
            rows={[
              [<span style={{ fontSize: '11px' }}>Value '05' is not facet-valid with respect to enumeration</span>, <span>Campo <code style={docStyles.codeInline}>tipoAtendimento</code> com valor invalido (05 nao existe no TISS)</span>, <span>Usar somente valores validos: 01,02,03,04,08,09,10,13,23. Lab = 23</span>],
              [<span style={{ fontSize: '11px' }}>Invalid content starting with 'procedimentosExecutados'</span>, <span>Multiplos blocos <code style={docStyles.codeInline}>procedimentosExecutados</code> (um por procedimento)</span>, <span>Usar UM bloco wrapper com multiplos <code style={docStyles.codeInline}>procedimentoExecutado</code> filhos</span>],
              [<span style={{ fontSize: '11px' }}>REMETENTE NAO IDENTIFICADO (glosa 5005)</span>, <span>Prestador nao cadastrado no ambiente TISS da operadora</span>, <span>Solicitar cadastro a UNIMED (TI ou setor de autorizacoes)</span>],
              [<span style={{ fontSize: '11px' }}>HTTP 502 / 504 Gateway Timeout</span>, <span>Servidor da operadora fora do ar (comum fora do horario comercial no HML)</span>, <span>Aguardar e tentar novamente no horario comercial</span>],
              [<span style={{ fontSize: '11px' }}>ECONNRESET / Socket hang up</span>, <span>Conexao TLS rejeitada pelo servidor (Node.js strict SSL)</span>, <span>Backend usa <code style={docStyles.codeInline}>rejectUnauthorized: false</code> no https.Agent</span>],
            ]}
          />

          <div style={docStyles.sectionTitle}>Estrutura XML — procedimentosExecutados (Lote)</div>
          <p style={docStyles.p}>O XSD exige <strong>um unico bloco</strong> wrapper contendo todos os procedimentos como filhos:</p>
          <pre style={docStyles.pre}>{`<!-- CORRETO: um wrapper, multiplos filhos -->
<ans:procedimentosExecutados>
  <ans:procedimentoExecutado>
    <ans:sequencialItem>1</ans:sequencialItem>
    ...
  </ans:procedimentoExecutado>
  <ans:procedimentoExecutado>
    <ans:sequencialItem>2</ans:sequencialItem>
    ...
  </ans:procedimentoExecutado>
</ans:procedimentosExecutados>

<!-- ERRADO: um wrapper por procedimento (gera erro Unmarshalling) -->
<ans:procedimentosExecutados>
  <ans:procedimentoExecutado>...</ans:procedimentoExecutado>
</ans:procedimentosExecutados>
<ans:procedimentosExecutados>
  <ans:procedimentoExecutado>...</ans:procedimentoExecutado>
</ans:procedimentosExecutados>`}</pre>

          <div style={docStyles.sectionTitle}>Codigos de Glosa Comuns</div>
          <DocTable
            headers={['Codigo', 'Descricao', 'Acao']}
            rows={[
              [<code style={docStyles.codeInline}>5005</code>, 'REMETENTE NAO IDENTIFICADO', 'Cadastro do prestador invalido/inativo no ambiente da operadora. Foi o erro que derrubou a homologacao apos a migracao para producao'],
              [<code style={docStyles.codeInline}>1308</code>, 'GUIA JA APRESENTADA', 'A guia ja foi enviada antes. Conferir se nao e reenvio duplicado antes de insistir'],
              [<code style={docStyles.codeInline}>1427</code>, 'NECESSIDADE DE AUDITORIA MEDICA', 'Nao e recusa definitiva: o exame caiu para auditoria da operadora. Comum em exames de alta complexidade'],
              [<code style={docStyles.codeInline}>1426</code>, 'NAO AUTORIZADO PELA AUDITORIA', 'Recusa apos analise da auditoria medica'],
            ]}
          />
        </DocSection>
      </div>

      {/* 6. Fluxo de Envio Manual */}
      <div style={s.card}>
        <DocSection title="6. Fluxo de Envio Manual (Recepcionista)">
          <ol>
            <li style={docStyles.li}>Recepcionista acessa: <strong>TISS UNIMED {'>'} aba Guias {'>'} sub-aba "Atendimentos UNIMED"</strong></li>
            <li style={docStyles.li}>Sistema busca automaticamente atendimentos com convenio UNIMED no SQL Server</li>
            <li style={docStyles.li}>Lista exibe: Local, Protocolo, Paciente, Carteirinha, Medico, Data, Status TISS</li>
            <li style={docStyles.li}>Recepcionista clica <strong>"Enviar UNIMED"</strong> no atendimento desejado</li>
            <li style={docStyles.li}>Sistema executa:
              <ul>
                <li style={docStyles.li}>Verifica se ja existe guia enviada (evita duplicata)</li>
                <li style={docStyles.li}>Busca dados completos no SQL Server (SOLICITACAO + GUIA + EXAMES)</li>
                <li style={docStyles.li}>Busca prestador configurado no PostgreSQL</li>
                <li style={docStyles.li}>Mapeia dados para formato TISS SADT via <code style={docStyles.codeInline}>mapToTissGuia()</code></li>
                <li style={docStyles.li}>Gera numero sequencial de guia e cria registro em <code style={docStyles.codeInline}>tiss_guias</code></li>
                <li style={docStyles.li}>Constroi XML SOAP com cabecalho, beneficiario, solicitante, procedimentos e hash MD5</li>
                <li style={docStyles.li}>Envia para endpoint <code style={docStyles.codeInline}>tissSolicitacaoProcedimento</code></li>
                <li style={docStyles.li}>Registra transacao em <code style={docStyles.codeInline}>tiss_transacoes</code></li>
                <li style={docStyles.li}>Parseia resposta e atualiza status (autorizado / enviado / erro)</li>
              </ul>
            </li>
            <li style={docStyles.li}>Tela atualiza mostrando novo status com badge colorido</li>
            <li style={docStyles.li}>Acoes disponiveis: <strong>Ver</strong> (detalhes), <strong>PDF</strong> (download), <strong>Status</strong> (consultar), <strong>Reenviar</strong> (se erro), <strong>Cancelar</strong></li>
          </ol>
          <div style={docStyles.note}>
            <strong>Envio por Protocolo:</strong> Alem da lista automatica, a recepcionista pode enviar manualmente informando LOCAL e PROTOCOLO no modal "Enviar por Protocolo". Util para envios avulsos ou retentativas.
          </div>
        </DocSection>
      </div>

      {/* 7. Fluxo Worker */}
      <div style={s.card}>
        <DocSection title="7. Fluxo de Envio Automatico (Worker)">
          <p style={docStyles.p}>Worker que roda em polling periodico no backend, verificando o SQL Server em busca de atendimentos UNIMED nao enviados.</p>
          <pre style={docStyles.pre}>{`[Worker Timer — a cada X minutos (padrao: 5)]
  |
  1. Verifica horario (07:00-22:00) e dia da semana (seg-sex)
     - Fora do horario → pula ciclo
  |
  2. Busca ate 20 atendimentos UNIMED no SQL Server
  |
  3. Para cada atendimento:
     a) Ja tem guia enviada/autorizada? → ignora
     b) Prestador configurado e ativo? → ignora se nao
     c) Tem carteirinha? → ignora se nao
     d) Tem exames na guia? → ignora se nao
     e) Mapeia, gera XML, envia SOAP
     f) Registra resultado
     g) Aguarda 1s antes do proximo
  |
  4. Salva log do ciclo (tiss_worker_log)`}</pre>
          <div style={docStyles.sectionTitle}>Controle via Interface</div>
          <ul>
            <li style={docStyles.li}><strong>Dashboard:</strong> Indicador visual (verde=ativo, laranja=parado), botoes Iniciar/Parar/Executar Agora</li>
            <li style={docStyles.li}><strong>Configuracao:</strong> Intervalo, horario inicio/fim, dias da semana</li>
            <li style={docStyles.li}><strong>Auto-Start:</strong> Se <code style={docStyles.codeInline}>auto_envio_ativo = 'true'</code>, o worker inicia automaticamente com o servidor</li>
          </ul>
        </DocSection>
      </div>

      {/* 8. Elegibilidade */}
      <div style={s.card}>
        <DocSection title="8. Fluxo de Elegibilidade">
          <ol>
            <li style={docStyles.li}>Na aba "Elegibilidade", digitar numero da carteirinha UNIMED</li>
            <li style={docStyles.li}>Sistema verifica cache (PostgreSQL, TTL 24h) — se valido, retorna do cache</li>
            <li style={docStyles.li}>Se cache expirado: busca prestador e config, constroi XML SOAP <code style={docStyles.codeInline}>pedidoElegibilidadeWS</code></li>
            <li style={docStyles.li}>Envia para <code style={docStyles.codeInline}>tissVerificaElegibilidade</code></li>
            <li style={docStyles.li}>Parseia resposta: se <code style={docStyles.codeInline}>reciboElegibilidade</code> {'→'} ELEGIVEL (nome, plano, validade); se <code style={docStyles.codeInline}>codigoGlosa</code> {'→'} NAO ELEGIVEL</li>
            <li style={docStyles.li}>Salva resultado no cache (expires_at = NOW() + 24h)</li>
            <li style={docStyles.li}>Exibe resultado com indicacao visual (verde/vermelho)</li>
          </ol>
        </DocSection>
      </div>

      {/* 9. Lotes */}
      <div style={s.card}>
        <DocSection title="9. Fluxo de Lotes (Faturamento)">
          <ol>
            <li style={docStyles.li}>Na aba "Lotes", clicar <strong>"Criar Lote"</strong></li>
            <li style={docStyles.li}>Sistema busca guias com status <code style={docStyles.codeInline}>autorizado</code> que nao pertencem a nenhum lote</li>
            <li style={docStyles.li}>Recepcionista seleciona quais guias incluir (checkbox)</li>
            <li style={docStyles.li}>Clica "Criar Lote" {'→'} cria registro em <code style={docStyles.codeInline}>tiss_lotes</code> + vincula guias</li>
            <li style={docStyles.li}>Clicar "Enviar" no lote {'→'} constroi XML <code style={docStyles.codeInline}>loteGuiasWS</code> + envia SOAP</li>
            <li style={docStyles.li}>Para lotes enviados, "Status" consulta protocolo na UNIMED {'→'} aceito/rejeitado/parcial</li>
          </ol>
        </DocSection>
      </div>

      {/* 10. Estrutura XML SOAP */}
      <div style={s.card}>
        <DocSection title="10. Estrutura XML SOAP">
          <DocTable
            headers={['Parametro', 'Valor']}
            rows={[
              ['Protocolo', 'SOAP 1.1 (Document/Literal)'],
              ['Encoding', 'ISO-8859-1'],
              ['Content-Type', <code style={docStyles.codeInline}>text/xml; charset=ISO-8859-1</code>],
              ['SOAPAction', <code style={docStyles.codeInline}>""</code>],
              ['Namespace TISS', <code style={docStyles.codeInline}>http://www.ans.gov.br/padroes/tiss/schemas</code>],
              ['Namespace SOAP', <code style={docStyles.codeInline}>http://schemas.xmlsoap.org/soap/envelope/</code>],
            ]}
          />
          <div style={docStyles.sectionTitle}>Estrutura do Envelope</div>
          <pre style={docStyles.pre}>{`<?xml version="1.0" encoding="ISO-8859-1"?>
<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"
               xmlns:ans="http://www.ans.gov.br/padroes/tiss/schemas">
  <soap:Body>
    <ans:{wrapperElement} xmlns:ans="...">
      <ans:cabecalho>
        <ans:identificacaoTransacao>
          <ans:tipoTransacao>{TIPO}</ans:tipoTransacao>
          <ans:sequencialTransacao>1</ans:sequencialTransacao>
          <ans:dataRegistroTransacao>YYYY-MM-DD</ans:dataRegistroTransacao>
          <ans:horaRegistroTransacao>HH:MM:SS</ans:horaRegistroTransacao>
        </ans:identificacaoTransacao>
        <ans:origem>
          <ans:identificacaoPrestador>
            <ans:CNPJ>{CNPJ_PRESTADOR}</ans:CNPJ>
          </ans:identificacaoPrestador>
        </ans:origem>
        <ans:destino>
          <ans:registroANS>{REGISTRO_ANS}</ans:registroANS>
        </ans:destino>
        <ans:Padrao>4.02.00</ans:Padrao>
        <ans:loginSenhaPrestador>
          <ans:loginPrestador>{LOGIN}</ans:loginPrestador>
          <ans:senhaPrestador>{SENHA}</ans:senhaPrestador>
        </ans:loginSenhaPrestador>
      </ans:cabecalho>
      {CORPO_ESPECIFICO_DA_OPERACAO}
      <ans:hash>{MD5_HASH}</ans:hash>
    </ans:{wrapperElement}>
  </soap:Body>
</soap:Envelope>`}</pre>
          <div style={docStyles.sectionTitle}>Hash MD5</div>
          <p style={docStyles.p}>
            O padrao TISS exige um hash MD5 em cada mensagem: coletar todos os <strong>valores folha</strong> (leaf values) do XML, concatenar sem separador, calcular MD5 hex. Implementado em <code style={docStyles.codeInline}>calculateTissHash()</code>.
          </p>
          <div style={docStyles.sectionTitle}>Wrapper Elements (NAO usam mensagemTISS)</div>
          <DocTable
            headers={['Operacao', 'Wrapper Request', 'Wrapper Response']}
            rows={[
              ['Elegibilidade', <code style={docStyles.codeInline}>pedidoElegibilidadeWS</code>, <code style={docStyles.codeInline}>respostaElegibilidadeWS</code>],
              ['Solicitacao', <code style={docStyles.codeInline}>solicitacaoProcedimentoWS</code>, <code style={docStyles.codeInline}>autorizacaoProcedimentoWS</code>],
              ['Lote Guias', <code style={docStyles.codeInline}>loteGuiasWS</code>, <code style={docStyles.codeInline}>protocoloRecebimentoWS</code>],
              ['Cancelamento', <code style={docStyles.codeInline}>cancelaGuiaWS</code>, <code style={docStyles.codeInline}>reciboCancelaGuiaWS</code>],
              ['Status Protocolo', <code style={docStyles.codeInline}>solicitacaoStatusProtocoloWS</code>, <code style={docStyles.codeInline}>situacaoProtocoloWS</code>],
            ]}
          />
          <div style={docStyles.sectionTitle}>Exemplo: XML Request de Elegibilidade</div>
          <pre style={docStyles.pre}>{`<?xml version="1.0" encoding="ISO-8859-1"?>
<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"
               xmlns:ans="http://www.ans.gov.br/padroes/tiss/schemas">
  <soap:Body>
    <ans:pedidoElegibilidadeWS xmlns:ans="...">
      <ans:cabecalho>
        <ans:identificacaoTransacao>
          <ans:tipoTransacao>VERIFICA_ELEGIBILIDADE</ans:tipoTransacao>
          <ans:sequencialTransacao>1</ans:sequencialTransacao>
          <ans:dataRegistroTransacao>2026-02-24</ans:dataRegistroTransacao>
          <ans:horaRegistroTransacao>16:30:37</ans:horaRegistroTransacao>
        </ans:identificacaoTransacao>
        <ans:origem>
          <ans:identificacaoPrestador>
            <ans:CNPJ>40138105000126</ans:CNPJ>
          </ans:identificacaoPrestador>
        </ans:origem>
        <ans:destino>
          <ans:registroANS>319121</ans:registroANS>
        </ans:destino>
        <ans:Padrao>4.02.00</ans:Padrao>
        <ans:loginSenhaPrestador>
          <ans:loginPrestador>14412401389</ans:loginPrestador>
          <ans:senhaPrestador>Unimed@2026</ans:senhaPrestador>
        </ans:loginSenhaPrestador>
      </ans:cabecalho>
      <ans:pedidoElegibilidade>
        <ans:dadosPrestador>
          <ans:cnpjContratado>40138105000126</ans:cnpjContratado>
        </ans:dadosPrestador>
        <ans:numeroCarteira>0031912100001001</ans:numeroCarteira>
      </ans:pedidoElegibilidade>
      <ans:hash>b63816729e592d73ef8150a5b7098515</ans:hash>
    </ans:pedidoElegibilidadeWS>
  </soap:Body>
</soap:Envelope>`}</pre>
          <div style={docStyles.sectionTitle}>Exemplo: XML Response (com Glosa 5005)</div>
          <pre style={docStyles.pre}>{`<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
  <soap:Body>
    <ans:respostaElegibilidadeWS xmlns:ans="...">
      <ans:cabecalho>...</ans:cabecalho>
      <ans:respostaElegibilidade>
        <ans:codigoGlosa>
          <ans:codigoGlosa>5005</ans:codigoGlosa>
          <ans:descricaoGlosa>REMETENTE NAO IDENTIFICADO</ans:descricaoGlosa>
        </ans:codigoGlosa>
      </ans:respostaElegibilidade>
      <ans:hash>231ce9a746289b7323fddb294969fa47</ans:hash>
    </ans:respostaElegibilidadeWS>
  </soap:Body>
</soap:Envelope>`}</pre>
        </DocSection>
      </div>

      {/* 11. Endpoints SOAP */}
      <div style={s.card}>
        <DocSection title="11. Endpoints SOAP UNIMED">
          <p style={docStyles.p}><strong>Base URL (HML):</strong> <code style={docStyles.codeInline}>https://s20atd-hml.divinopolis.sgusuite.com.br/WSTiss3/http/v4_02_00/</code></p>
          <DocTable
            headers={['#', 'Operacao', 'Path', 'tipoTransacao']}
            rows={[
              ['1', 'Elegibilidade', <code style={docStyles.codeInline}>tissVerificaElegibilidade</code>, 'VERIFICA_ELEGIBILIDADE'],
              ['2', 'Solicitacao de Procedimentos', <code style={docStyles.codeInline}>tissSolicitacaoProcedimento</code>, 'SOLICITACAO_PROCEDIMENTOS'],
              ['3', 'Lote de Guias', <code style={docStyles.codeInline}>tissLoteGuias</code>, 'ENVIO_LOTE_GUIAS'],
              ['4', 'Cancelamento de Guia', <code style={docStyles.codeInline}>tissCancelaGuia</code>, 'CANCELA_GUIA'],
              ['5', 'Status de Protocolo', <code style={docStyles.codeInline}>tissSituacaoProtocolo</code>, 'SOLIC_STATUS_PROTOCOLO'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Endpoints Adicionais (nao implementados)</div>
          <DocTable
            headers={['Endpoint', 'Descricao']}
            rows={[
              ['tissComunicacaoBeneficiario', 'Comunicacao com beneficiario'],
              ['tissLoteAnexo', 'Envio de anexos'],
              ['tissRecursoGlosa', 'Recurso contra glosas'],
              ['tissSolicitacaoDemonstrativoRetorno', 'Demonstrativo de retorno'],
              ['tissSolicitacaoStatusAutorizacao', 'Status de autorizacao'],
              ['tissEnvioDocumentos', 'Envio de documentos'],
            ]}
          />
        </DocSection>
      </div>

      {/* 12. Endpoints REST */}
      <div style={s.card}>
        <DocSection title="12. Endpoints REST (API Interna)">
          <p style={docStyles.p}>Todos requerem autenticacao JWT (<code style={docStyles.codeInline}>Authorization: Bearer {'<token>'}</code>), exceto o endpoint de PDF que tambem aceita API Key.</p>
          <div style={docStyles.sectionTitle}>Configuracao</div>
          <DocTable
            headers={['Metodo', 'Rota', 'Descricao']}
            rows={[
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/config</code>, 'Retorna configuracoes (senha mascarada)'],
              [<strong>PUT</strong>, <code style={docStyles.codeInline}>/api/tiss/config</code>, 'Atualiza configuracoes em bulk'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/prestadores</code>, 'Lista prestadores por LOCAL'],
              [<strong>PUT</strong>, <code style={docStyles.codeInline}>/api/tiss/prestadores/:id</code>, 'Atualiza prestador'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/config/testar-conexao</code>, 'Testa conexao SOAP'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Guias</div>
          <DocTable
            headers={['Metodo', 'Rota', 'Descricao']}
            rows={[
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/guias/dashboard</code>, 'Contadores para dashboard'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/guias</code>, 'Lista guias (filtros: status, local_id, search, datas)'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/guias/recentes</code>, 'Ultimas guias'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/guias/:id</code>, 'Detalhe de uma guia'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/guias/:id/pdf</code>, 'Download PDF da guia (JWT ou API Key)'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/guias/enviar</code>, 'Enviar guia SADT (body: local, protocolo)'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/guias/:id/reenviar</code>, 'Reenviar guia com erro'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/guias/:id/status</code>, 'Consultar status na UNIMED'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/guias/:id/cancelar</code>, 'Cancelar guia'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/atendimentos-unimed</code>, 'Lista atendimentos UNIMED do SQL Server'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Lotes</div>
          <DocTable
            headers={['Metodo', 'Rota', 'Descricao']}
            rows={[
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/lotes</code>, 'Lista lotes'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/lotes/:id</code>, 'Detalhe do lote com guias'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/lotes/criar</code>, 'Criar lote (body: guia_ids, local_id)'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/lotes/:id/enviar</code>, 'Enviar lote para operadora'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/lotes/:id/status</code>, 'Consultar status do lote'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/lotes/:id/reenviar</code>, 'Reenviar lote'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Elegibilidade</div>
          <DocTable
            headers={['Metodo', 'Rota', 'Descricao']}
            rows={[
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/elegibilidade/verificar</code>, 'Verificar elegibilidade (body: carteirinha)'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/elegibilidade/historico</code>, 'Historico de verificacoes'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Worker</div>
          <DocTable
            headers={['Metodo', 'Rota', 'Descricao']}
            rows={[
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/worker/status</code>, 'Status atual do worker'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/worker/iniciar</code>, 'Iniciar worker'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/worker/parar</code>, 'Parar worker'],
              [<strong>POST</strong>, <code style={docStyles.codeInline}>/api/tiss/worker/executar-agora</code>, 'Forcar execucao de ciclo'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/worker/historico</code>, 'Historico de ciclos'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Transacoes (Log)</div>
          <DocTable
            headers={['Metodo', 'Rota', 'Descricao']}
            rows={[
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/transacoes</code>, 'Lista transacoes (filtros: operacao, sucesso, datas)'],
              [<strong>GET</strong>, <code style={docStyles.codeInline}>/api/tiss/transacoes/:id</code>, 'Detalhe com XML completo'],
            ]}
          />
        </DocSection>
      </div>

      {/* 13. Frontend */}
      <div style={s.card}>
        <DocSection title="13. Frontend — Tela TISS UNIMED">
          <p style={docStyles.p}>
            <strong>Arquivo:</strong> <code style={docStyles.codeInline}>client/src/pages/TissUnimed.js</code> | <strong>Rota:</strong> <code style={docStyles.codeInline}>/tiss-unimed</code> | <strong>Menu:</strong> Financeiro {'>'} TISS UNIMED
          </p>
          <DocTable
            headers={['Aba', 'Descricao']}
            rows={[
              [<strong>Dashboard</strong>, 'Contadores (hoje, pendentes, autorizadas, negadas, erros), status do worker, atividade recente'],
              [<strong>Guias</strong>, 'Sub-abas: "Atendimentos UNIMED" (SQL Server + botao Enviar) e "Guias Enviadas" (PG com acoes)'],
              [<strong>Lotes</strong>, 'Lista de lotes de faturamento. Criar lote, enviar, consultar status'],
              [<strong>Elegibilidade</strong>, 'Campo para carteirinha, resultado visual, historico'],
              [<strong>Configuracao</strong>, 'Conexao SOAP, envio automatico, prestadores. Botao "Testar Conexao"'],
              [<strong>Log</strong>, 'Transacoes SOAP paginadas com filtros. Modal XML completo'],
              [<strong>Doc</strong>, 'Esta documentacao completa do modulo'],
            ]}
          />
        </DocSection>
      </div>

      {/* 14. Status Atual */}
      <div style={s.card}>
        <DocSection title="14. Status Atual da Integracao" defaultOpen>
          <div style={docStyles.sectionTitle}>Concluido</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '14px' }}>
            {[
              'Comunicacao SOAP funcional',
              'XML validado pelo schema XSD TISS v4.02.00',
              'Frontend completo com 7 abas',
              'Backend com 10 modulos',
              '7 tabelas PostgreSQL com seeds',
              'Worker de envio automatico',
              'Log de transacoes SOAP',
              'Cache de elegibilidade (24h)',
              'Tratamento de glosas e SOAP Faults',
              'Reenvio e cancelamento de guias',
              'Lotes de faturamento',
              'Mapeamento automatico SQL Server para TISS',
              'Download PDF da guia (JWT + API Key)',
              'Solicitacao de guia SADT (HML OK)',
              'Autorizacao/Negativa parseada corretamente',
              'Autorizacao Parcial (status 3) tratada',
              'Lote de faturamento enviado (HML OK)',
              'Validacao tipoAtendimento contra enum TISS',
              'Estrutura XML procedimentosExecutados corrigida',
              'Extracao de motivo negativa e glosas parciais',
            ].map((item, i) => (
              <span key={i} style={docStyles.statusOk}>{item}</span>
            ))}
          </div>
          <div style={docStyles.sectionTitle}>Homologacao em Andamento</div>
          <div style={docStyles.note}>
            <strong>Ambiente HML funcional:</strong> Guias de solicitacao e lotes de faturamento estao sendo enviados e aceitos pela UNIMED em homologacao. Erros de validacao XSD (tipoAtendimento, procedimentosExecutados) ja foram corrigidos.
          </div>
          <div style={docStyles.sectionTitle}>Pendente</div>
          <ul>
            <li style={docStyles.li}><span style={docStyles.statusPend}>Pendente</span> Confirmar <code style={docStyles.codeInline}>codigoPrestadorNaOperadora</code> para cada unidade</li>
            <li style={docStyles.li}><span style={docStyles.statusPend}>Pendente</span> Validar recebimento/processamento dos lotes pelo faturamento UNIMED</li>
            <li style={docStyles.li}><span style={docStyles.statusPend}>Pendente</span> Endpoint de producao (informado pela UNIMED apos homologacao)</li>
            <li style={docStyles.li}><span style={docStyles.statusPend}>Pendente</span> Testes com demais unidades (Matriz, Pedra do Indaia, Camacho)</li>
          </ul>
        </DocSection>
      </div>

      {/* 15. Configuracoes Pos-Homologacao */}
      <div style={s.card}>
        <DocSection title="15. Configuracoes Pos-Homologacao">
          <div style={docStyles.sectionTitle}>Apos UNIMED cadastrar o laboratorio no HML</div>
          <ol>
            <li style={docStyles.li}>Acessar <strong>TISS UNIMED {'>'} Configuracao</strong></li>
            <li style={docStyles.li}>Clicar <strong>Testar Conexao</strong> — deve retornar sucesso (sem erro 5005)</li>
            <li style={docStyles.li}>Testar <strong>Elegibilidade</strong> com uma carteirinha valida</li>
            <li style={docStyles.li}>Testar <strong>Envio de Guia</strong> com um atendimento real</li>
          </ol>
          <div style={docStyles.sectionTitle}>Apos receber codigo do prestador na operadora</div>
          <ol>
            <li style={docStyles.li}>Acessar <strong>TISS UNIMED {'>'} Configuracao {'>'} Prestadores</strong></li>
            <li style={docStyles.li}>Para cada LOCAL (Matriz, Itapecerica, Pedra do Indaia, Camacho): preencher "Cod. Operadora" e salvar</li>
          </ol>
          <div style={docStyles.sectionTitle}>Para migrar para Producao</div>
          <ol>
            <li style={docStyles.li}>Solicitar liberacao do ambiente PRD a UNIMED</li>
            <li style={docStyles.li}>Preencher <strong>Endpoint PROD</strong> na Configuracao</li>
            <li style={docStyles.li}>Alterar <strong>Ambiente</strong> de "Homologacao" para "Producao"</li>
            <li style={docStyles.li}>Clicar <strong>Testar Conexao</strong> para validar</li>
          </ol>
          <div style={docStyles.sectionTitle}>Para ativar envio automatico</div>
          <ol>
            <li style={docStyles.li}>Configurar intervalo (5 min recomendado), horario (07:00-22:00), dias (seg-sex)</li>
            <li style={docStyles.li}>Salvar configuracoes</li>
            <li style={docStyles.li}>No Dashboard, clicar <strong>Iniciar</strong> no box do Worker</li>
            <li style={docStyles.li}>Verificar indicador <strong>verde</strong> (Ativo)</li>
          </ol>
        </DocSection>
      </div>

      {/* 16. Contatos e Referencias */}
      <div style={s.card}>
        <DocSection title="16. Contatos e Referencias">
          <div style={docStyles.sectionTitle}>Contatos</div>
          <DocTable
            headers={['Pessoa', 'Funcao', 'Contato']}
            rows={[
              [<strong>Gustavo Lucas</strong>, 'Analista de Sistemas — UNIMED Divinopolis', 'gustavo.lucas@unimed144.coop.br / (37) 3229-5285'],
              [<strong>Luciene Chagas</strong>, 'Faturamento — Lab Santa Rita', 'faturamentolabsantarita@yahoo.com'],
              [<strong>Rafael Junior</strong>, 'Desenvolvedor — VIP Tecnologia', 'rafael@viptecnologia.com.br'],
            ]}
          />
          <div style={docStyles.sectionTitle}>Arquivos no Repositorio</div>
          <DocTable
            headers={['Arquivo', 'Descricao']}
            rows={[
              [<code style={docStyles.codeInline}>integracaounimed/email.txt</code>, 'Thread de emails com a UNIMED'],
              [<code style={docStyles.codeInline}>integracaounimed/DOCUMENTACAO_TISS.md</code>, 'Documentacao completa em Markdown'],
              [<code style={docStyles.codeInline}>integracaounimed/xml_request_elegibilidade.xml</code>, 'Exemplo XML request'],
              [<code style={docStyles.codeInline}>integracaounimed/xml_response_elegibilidade.xml</code>, 'Exemplo XML response (erro 5005)'],
              [<code style={docStyles.codeInline}>integracaounimed/PadroTISS_*.zip/pdf</code>, 'Documentacao oficial TISS ANS'],
            ]}
          />
          <div style={{ textAlign: 'center', padding: '12px 0', fontSize: '11px', color: '#aaa', borderTop: '1px solid #eee', marginTop: '8px' }}>
            Documento gerado em 24/02/2026 — VIP Tecnologia LTDA
          </div>
        </DocSection>
      </div>
    </>
  );
}

// ==================== AJUDA (GUIA PRATICO) ====================

function AjudaSection({ icon, title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={ajudaStyles.section}>
      <div style={ajudaStyles.sectionHeader} onClick={() => setOpen(!open)}>
        <span style={ajudaStyles.sectionIcon}>{icon}</span>
        <h3 style={ajudaStyles.sectionTitle}>{title}</h3>
        <span style={{ ...ajudaStyles.sectionToggle, transform: open ? 'rotate(180deg)' : 'rotate(0)' }}>&#9660;</span>
      </div>
      {open && <div>{children}</div>}
    </div>
  );
}

function AjudaStep({ n, children }) {
  return (
    <div style={ajudaStyles.step}>
      <div style={ajudaStyles.stepNumber}>{n}</div>
      <div style={ajudaStyles.stepText}>{children}</div>
    </div>
  );
}

export function AjudaContent() {
  return (
    <div style={ajudaStyles.container}>
      {/* Introducao */}
      <div style={ajudaStyles.intro}>
        <p style={ajudaStyles.introTitle}>Guia Rapido — TISS UNIMED</p>
        <p style={ajudaStyles.introText}>
          Este modulo envia as guias de exame dos pacientes UNIMED automaticamente, sem precisar entrar no portal da operadora.
          Aqui voce encontra o passo a passo de cada funcao do sistema.
        </p>
      </div>

      {/* A — Como enviar uma guia */}
      <AjudaSection icon="📤" title="Como enviar uma guia" defaultOpen={true}>
        <AjudaStep n={1}>
          Va na aba <span style={ajudaStyles.bold}>Guias</span> e depois na sub-aba <span style={ajudaStyles.bold}>Atendimentos UNIMED</span>.
        </AjudaStep>
        <AjudaStep n={2}>
          Localize o paciente na lista. Use os filtros de <span style={ajudaStyles.bold}>Local</span> e <span style={ajudaStyles.bold}>Data</span> para encontrar mais rapido.
        </AjudaStep>
        <AjudaStep n={3}>
          Clique no botao <span style={ajudaStyles.bold}>Enviar UNIMED</span> na linha do paciente.
        </AjudaStep>
        <AjudaStep n={4}>
          Aguarde — o status da guia vai mudar. Veja o que cada status significa:
        </AjudaStep>
        <div style={ajudaStyles.statusList}>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#2e7d32' }}></span>
            <span><span style={ajudaStyles.bold}>Autorizado</span> — Tudo certo, a UNIMED aprovou a guia.</span>
          </div>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#1565c0' }}></span>
            <span><span style={ajudaStyles.bold}>Enviado</span> — A guia foi enviada e esta aguardando resposta da UNIMED.</span>
          </div>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#c62828' }}></span>
            <span><span style={ajudaStyles.bold}>Negado</span> — A UNIMED recusou a guia. Clique em <span style={ajudaStyles.bold}>Ver</span> para saber o motivo.</span>
          </div>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#c62828' }}></span>
            <span><span style={ajudaStyles.bold}>Erro</span> — Falha tecnica no envio. Clique em <span style={ajudaStyles.bold}>Reenviar</span>.</span>
          </div>
        </div>
        <div style={ajudaStyles.tip}>
          <strong>Dica:</strong> Tambem e possivel enviar pelo botao <span style={ajudaStyles.bold}>Enviar por Protocolo</span>, digitando o numero do protocolo diretamente.
        </div>
      </AjudaSection>

      {/* B — Como baixar o PDF da guia */}
      <AjudaSection icon="📄" title="Como baixar o PDF da guia">
        <AjudaStep n={1}>
          Na aba <span style={ajudaStyles.bold}>Guias</span>, va na sub-aba <span style={ajudaStyles.bold}>Guias Enviadas</span>.
        </AjudaStep>
        <AjudaStep n={2}>
          Clique no botao <span style={ajudaStyles.bold}>PDF</span> na linha da guia que deseja baixar.
        </AjudaStep>
        <AjudaStep n={3}>
          O arquivo sera aberto ou baixado automaticamente no seu navegador.
        </AjudaStep>
        <div style={ajudaStyles.tip}>
          <strong>Dica:</strong> Voce tambem pode abrir os detalhes da guia e clicar em <span style={ajudaStyles.bold}>Baixar PDF</span> dentro do modal.
        </div>
      </AjudaSection>

      {/* C — Como verificar elegibilidade */}
      <AjudaSection icon="💳" title="Como verificar elegibilidade do paciente">
        <AjudaStep n={1}>
          Va na aba <span style={ajudaStyles.bold}>Elegibilidade</span>.
        </AjudaStep>
        <AjudaStep n={2}>
          Digite o numero da <span style={ajudaStyles.bold}>carteirinha UNIMED</span> do paciente.
        </AjudaStep>
        <AjudaStep n={3}>
          Clique em <span style={ajudaStyles.bold}>Verificar</span>.
        </AjudaStep>
        <AjudaStep n={4}>
          O resultado aparece na tela:
        </AjudaStep>
        <div style={ajudaStyles.statusList}>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#2e7d32' }}></span>
            <span><span style={ajudaStyles.bold}>Elegivel</span> — O paciente esta ativo no plano e pode ser atendido.</span>
          </div>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#c62828' }}></span>
            <span><span style={ajudaStyles.bold}>Nao elegivel</span> — O paciente nao esta ativo. Verifique os dados da carteirinha.</span>
          </div>
        </div>
      </AjudaSection>

      {/* D — Como criar e enviar um lote */}
      <AjudaSection icon="📦" title="Como criar e enviar um lote">
        <AjudaStep n={1}>
          Va na aba <span style={ajudaStyles.bold}>Lotes</span>.
        </AjudaStep>
        <AjudaStep n={2}>
          Clique em <span style={ajudaStyles.bold}>Criar Lote</span>.
        </AjudaStep>
        <AjudaStep n={3}>
          Selecione as guias autorizadas usando os <span style={ajudaStyles.bold}>checkboxes</span> na lista.
        </AjudaStep>
        <AjudaStep n={4}>
          Clique em <span style={ajudaStyles.bold}>Criar Lote</span> para agrupar as guias selecionadas.
        </AjudaStep>
        <AjudaStep n={5}>
          Na lista de lotes, clique em <span style={ajudaStyles.bold}>Enviar</span> para transmitir o lote para a UNIMED.
        </AjudaStep>
        <div style={ajudaStyles.tip}>
          <strong>Dica:</strong> Os lotes agrupam varias guias em um unico envio, facilitando o controle do faturamento.
        </div>
      </AjudaSection>

      {/* E — Envio Automatico (Worker) */}
      <AjudaSection icon="🤖" title="O que e o Envio Automatico?">
        <p style={{ fontSize: '13.5px', color: '#333', lineHeight: '1.6', margin: '0 0 12px 0' }}>
          O sistema pode enviar guias sozinho, sem voce precisar clicar uma por uma.
          No <span style={ajudaStyles.bold}>Dashboard</span>, o box do envio automatico mostra o status:
        </p>
        <div style={ajudaStyles.statusList}>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#2e7d32' }}></span>
            <span><span style={ajudaStyles.bold}>Verde (Ativo)</span> — O envio automatico esta ligado e funcionando.</span>
          </div>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#e65100' }}></span>
            <span><span style={ajudaStyles.bold}>Laranja (Parado)</span> — O envio automatico esta desligado.</span>
          </div>
        </div>
        <p style={{ fontSize: '13.5px', color: '#333', lineHeight: '1.6', margin: '12px 0 0 0' }}>
          <span style={ajudaStyles.bold}>Como ligar:</span> Va na aba <span style={ajudaStyles.bold}>Configuracao</span>, ative a opcao do envio automatico e depois clique em <span style={ajudaStyles.bold}>Iniciar</span> no Dashboard.
        </p>
        <div style={ajudaStyles.tip}>
          <strong>Dica:</strong> Quando ativo, as guias novas sao enviadas automaticamente a cada 5 minutos.
        </div>
      </AjudaSection>

      {/* F — Entendendo os codigos */}
      <AjudaSection icon="📋" title="Entendendo os codigos da UNIMED">
        <p style={{ fontSize: '13.5px', color: '#333', lineHeight: '1.6', margin: '0 0 14px 0' }}>
          Quando a UNIMED responde uma guia, ela envia um <span style={ajudaStyles.bold}>codigo de status</span> que indica o resultado:
        </p>
        <div style={ajudaStyles.statusList}>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#2e7d32' }}></span>
            <span><span style={ajudaStyles.bold}>Codigo 1 — Autorizado:</span> Todos os exames foram aprovados.</span>
          </div>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#c62828' }}></span>
            <span><span style={ajudaStyles.bold}>Codigo 2 — Negado:</span> A UNIMED recusou a guia inteira. Veja o motivo clicando em "Ver".</span>
          </div>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#e65100' }}></span>
            <span><span style={ajudaStyles.bold}>Codigo 3 — Autorizado Parcial:</span> Alguns exames foram aprovados, mas outros nao. Aparece como "Autorizada" com observacao do motivo da glosa parcial.</span>
          </div>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#757575' }}></span>
            <span><span style={ajudaStyles.bold}>Codigo 4 — Cancelado pelo Prestador:</span> O laboratorio cancelou a guia.</span>
          </div>
          <div style={ajudaStyles.statusItem}>
            <span style={{ ...ajudaStyles.statusDot, backgroundColor: '#757575' }}></span>
            <span><span style={ajudaStyles.bold}>Codigo 5 — Cancelado pela Operadora:</span> A UNIMED cancelou a guia.</span>
          </div>
        </div>
        <div style={ajudaStyles.tip}>
          <strong>Dica:</strong> Na tela de detalhes da guia, o sistema mostra o codigo e o significado automaticamente com uma cor correspondente (verde=autorizado, vermelho=negado, laranja=parcial).
        </div>

        <p style={{ fontSize: '13.5px', color: '#333', lineHeight: '1.6', margin: '16px 0 10px 0' }}>
          <span style={ajudaStyles.bold}>Codigos de glosa</span> sao os motivos que a UNIMED informa quando nega ou glosa parcialmente um exame. Exemplos comuns:
        </p>
        <div style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', padding: '14px 18px', margin: '0 0 8px' }}>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '8px' }}>
            <code style={{ ...docStyles.codeInline, fontSize: '12px', fontWeight: '700' }}>1427</code>
            <span style={{ fontSize: '13px', color: '#555' }}>Necessidade de auditoria medica — o exame foi para analise, nao e recusa definitiva</span>
          </div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '8px' }}>
            <code style={{ ...docStyles.codeInline, fontSize: '12px', fontWeight: '700' }}>1308</code>
            <span style={{ fontSize: '13px', color: '#555' }}>Guia ja apresentada — conferir se nao e envio duplicado</span>
          </div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <code style={{ ...docStyles.codeInline, fontSize: '12px', fontWeight: '700' }}>5005</code>
            <span style={{ fontSize: '13px', color: '#555' }}>Remetente nao identificado — prestador nao cadastrado/inativo na UNIMED</span>
          </div>
        </div>
        <p style={{ fontSize: '12.5px', color: '#666', margin: '8px 0 0 0' }}>
          A descricao completa de qualquer codigo aparece automaticamente na tela da guia — o sistema traduz
          os 640 codigos da Tabela 38 do padrao TISS (ANS).
        </p>
        <div style={ajudaStyles.warning}>
          <strong>Importante:</strong> Quando uma guia aparece com status "Autorizada" mas mostra um motivo/glosa, significa que e uma <span style={ajudaStyles.bold}>autorizacao parcial</span> — parte dos exames foi aprovada e outra parte glosada. Informe o setor de faturamento.
        </div>
      </AjudaSection>

      {/* G — O que fazer quando da erro */}
      <AjudaSection icon="🔧" title="O que fazer quando da erro?">
        <AjudaStep n={1}>
          <span style={ajudaStyles.bold}>Se o status e "Erro":</span> Clique no botao <span style={ajudaStyles.bold}>Reenviar</span> na linha da guia.
        </AjudaStep>
        <AjudaStep n={2}>
          <span style={ajudaStyles.bold}>Se o status e "Negado":</span> Clique em <span style={ajudaStyles.bold}>Ver</span> para consultar o motivo da negativa. Se necessario, entre em contato com a UNIMED.
        </AjudaStep>
        <AjudaStep n={3}>
          <span style={ajudaStyles.bold}>Se o status e "Enviado" ha muito tempo:</span> Clique no botao <span style={ajudaStyles.bold}>Status</span> para consultar a situacao atualizada na UNIMED.
        </AjudaStep>
        <div style={ajudaStyles.warning}>
          <strong>Atencao:</strong> Se os erros forem frequentes, avise o setor de TI para verificar a conexao com a UNIMED.
        </div>
      </AjudaSection>

      {/* H — Contatos uteis */}
      <AjudaSection icon="📞" title="Contatos uteis">
        <div style={ajudaStyles.contactCard}>
          <div style={ajudaStyles.contactItem}>
            <div style={ajudaStyles.contactName}>UNIMED Divinopolis</div>
            <div style={ajudaStyles.contactDetail}>
              Gustavo Lucas<br />
              gustavo.lucas@unimed144.coop.br<br />
              (37) 3229-5285
            </div>
          </div>
          <div style={ajudaStyles.contactItem}>
            <div style={ajudaStyles.contactName}>TI — VIP Tecnologia</div>
            <div style={ajudaStyles.contactDetail}>
              Rafael Junior<br />
              rafael@viptecnologia.com.br
            </div>
          </div>
        </div>
      </AjudaSection>
    </div>
  );
}
